/* oxlint-disable typescript/no-non-null-assertion -- intentional null assertions */
// Process escaped chars and hardbreaks

import type StateInline from '../state-inline'
import { isSpace } from '../../../common/utils'

const ESCAPED: number[] = []

for (let i = 0; i < 256; i++) {
  ESCAPED.push(0)
}

for (const ch of '\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split(''))
  ESCAPED[ch.charCodeAt(0)] = 1

export default function escape(state: StateInline, silent: boolean) {
  let pos = state.pos
  const max = state.posMax

  if (state.src.charCodeAt(pos) !== 0x5c /* \ */) return false
  pos++

  // '\' at the end of the inline block
  if (pos >= max) return false

  let ch1 = state.src.charCodeAt(pos)

  if (ch1 === 0x0a) {
    if (!silent) {
      state.push('hardbreak', 'br', 0)
    }

    pos++
    // skip leading whitespaces from next line
    while (pos < max) {
      ch1 = state.src.charCodeAt(pos)
      if (!isSpace(ch1)) break
      pos++
    }

    state.pos = pos
    return true
  }

  let escapedStr = state.src[pos]

  if (ch1 >= 0xd800 && ch1 <= 0xdbff && pos + 1 < max) {
    const ch2 = state.src.charCodeAt(pos + 1)

    if (ch2 >= 0xdc00 && ch2 <= 0xdfff) {
      escapedStr += state.src[pos + 1]
      pos++
    }
  }

  const origStr = `\\${escapedStr}`

  if (!silent) {
    const token = state.push('text_special', '', 0)

    if (ch1 < 256 && ESCAPED[ch1] !== 0) {
      token.content = escapedStr
    } else {
      token.content = origStr
    }

    token.markup = origStr
    token.info = 'escape'
  }

  state.pos = pos + 1
  return true
}
